<template>
  <div class="cbaas-contract-param-table">
    <normal-table
      :table-data="list"
      :table-col="headList"
      :show-pagination="false"
      :use-empty="false"
      :paging="{ total: list.length }"
      :show-border="true"
    >
    </normal-table>
  </div>
</template>

<script>
export default {
  name: 'ParamTable',
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    headList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('cbaas-contract-param-table', (), ());
.cbaas-contract-param-table {
  @include adaptation(
    (
      --cbaas-contract-param-table-padding-top: 8px,
      --cbaas-contract-param-table-header-height: 36px,
      --cbaas-contract-param-table-header-cell-padding: 8px 0,
      --cbaas-contract-param-table-body-item-height: 38px,
      --cbaas-contract-param-table-empty-item-height: 38px
    )
  );
  padding-top: var(--cbaas-contract-param-table-padding-top);

  .normal-table-wrap {
    /deep/ {
      .normal-table {
        .el-table {
          .el-table__header {
            tr {
              height: var(--cbaas-contract-param-table-header-height);

              .el-table__cell {
                padding: var(--cbaas-contract-param-table-header-cell-padding);
              }
            }
          }

          .el-table__body {
            tr {
              height: var(--cbaas-contract-param-table-body-item-height);
            }
          }

          .el-table__empty-block {
            min-height: var(--cbaas-contract-param-table-empty-item-height);

            .el-table__empty-text {
              line-height: var(--cbaas-contract-param-table-empty-item-height);
            }
          }
        }
      }
    }
  }
}
</style>
